export default __webpack_public_path__ + "static/media/avatar-placeholder.67f2bd72.svg";